/**
 * Estrae in modo sicuro un messaggio di errore stringa da un errore axios.
 * FastAPI/pydantic restituisce `detail` come stringa per errori applicativi (HTTPException),
 * ma come ARRAY di oggetti {type, loc, msg, ...} per errori di validazione (422).
 * Passare direttamente un array/oggetto a `toast.error()` o `setError()` causa un crash
 * React ("Objects are not valid as a React child").
 */
export function getErrorMessage(err: any, fallback: string): string {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail) && detail.length > 0) {
    return detail[0]?.msg || fallback;
  }
  return fallback;
}
